import DepartureFilterManager from '../features/departure-filter/departure-filter-manager.js';

export default class AppInitializer {
	constructor() {
		this.init();
	}

	init() {
		const departureFilterManager = new DepartureFilterManager();
		departureFilterManager.init();
	}
}
